export default __webpack_public_path__ + "static/media/certification-empty.bb238ef9.png";